import React from 'react';
import { TableCell, TableCellProps } from '@mui/material';
import styled from 'styled-components';
import { Typography } from '../typography';
import { Tooltip } from '../tooltip';

const WrapperCenter = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  align-items: center;
  grid-column-gap: 1.2rem;
  height: max-content;
`;

export const TableCellWrapperCenter: React.FC<TableCellProps> = ({
  children,
  ...props
}: TableCellProps) => {
  return (
    <TableCell {...props}>
      <WrapperCenter>{children}</WrapperCenter>
    </TableCell>
  );
};

const HiddenTextWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  align-items: center;
  grid-column-gap: 1.2rem;
  height: max-content;
  width: 100% !important;

  & > * {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

export const TableCellHiddenText = React.forwardRef<HTMLTableCellElement, TableCellProps>(
  ({ children, ...props }, ref) => {
    return (
      <TableCell ref={ref} {...props}>
        <HiddenTextWrapper>
          <Typography variant={'textS'}>{children}</Typography>
        </HiddenTextWrapper>
      </TableCell>
    );
  },
);

TableCellHiddenText.displayName = 'TableCellHiddenText';

export const TableCellComment = ({ comment }: { comment: string }) => {
  return (
    <Tooltip title={comment} placement={'top'} arrow>
      <TableCellHiddenText align={'left'}>{comment}</TableCellHiddenText>
    </Tooltip>
  );
};
